import { render, staticRenderFns } from "./Calendar-Setting.vue?vue&type=template&id=c8c4b2be&scoped=true"
import script from "./Calendar-Setting.vue?vue&type=script&lang=js"
export * from "./Calendar-Setting.vue?vue&type=script&lang=js"
import style0 from "./Calendar-Setting.vue?vue&type=style&index=0&id=c8c4b2be&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8c4b2be",
  null
  
)

export default component.exports